<template>
  <div
    v-if="points.length > 0"
    ref="heatmap"
    :style="`width: ${mapWidth}; height: ${mapHeight}`"/>
  <p v-else
     class="msg-not-sector">NO HAY PUNTOS PARA MOSTRAR</p>
</template>

<script>
export default {
  name: 'HeatMap',
  props: {
    latitude: {
      type: Number,
      default: -33.436148,
    },
    longitude: {
      type: Number,
      default: -70.6355413,
    },
    zoom: {
      type: Number,
      default: 10,
    },
    type: {
      type: String,
      default: 'roadmap',
    },
    points: {
      type: Array,
      required: true,
    },
    width: {
      type: [String, Number],
      default: '100%',
    },
    height: {
      type: [String, Number],
      default: '100%',
    },
    opacity: {
      type: Number,
      default: 0.75,
    },
    maxIntensity: {
      type: Number,
      default: 0,
    },
    radius: {
      type: Number,
      default: 15,
    },
    gradient: {
      type: Array,
      default() {
        return ['rgba(170, 213, 0, 0)', 'rgba(170, 213, 0, 1)'];
      },
    },
  },
  data() {
    return {
      style: [{
        elementType: 'geometry',
        stylers: [{ color: '#f5f5f5' }],
      }, {
        elementType: 'labels.icon',
        stylers: [{ visibility: 'true' }],
      }, {
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      }, {
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#f5f5f5' }],
      }, {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#bdbdbd' }],
      }, {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }],
      }, {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      }, {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }],
      }, {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }],
      }, {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      }, {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#dadada' }],
      }, {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      }, {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      }, {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }],
      }, {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }],
      }, {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#eaf4fe' }],
      }, {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      }],
    };
  },
  watch: {
    // eslint-disable-next-line consistent-return
    points() {
      if (this.points.length > 0) {
        return this.$gmapApiPromiseLazy().then(() => {
          this.$mapObject = this.getMap();
          this.points.forEach((p) => {
          // eslint-disable-next-line
          this.$heatmap = new google.maps.visualization.HeatmapLayer({
              zoom: this.zoom,
              radius: this.radius,
              map: this.$mapObject,
              opacity: this.opacity,
              data: this.heatmapPoints(p.points),
              maxIntensity: this.maxIntensity,
              gradient: this.getGradient(p.color),
            });
            this.$heatmap.setMap(this.$mapObject);
          });
          this.getFitBounds(this.points.map(p => p.points));
        });
      }
    },
  },
  methods: {
    getFitBounds(points) {
      // eslint-disable-next-line no-undef
      const bounds = new google.maps.LatLngBounds();
      points.flat().forEach((p) => { bounds.extend(p); });
      return this.$mapObject.fitBounds(bounds, 0);
    },
    getMap() {
      // eslint-disable-next-line no-undef
      return new google.maps.Map(this.$refs.heatmap, {
        zoom: this.zoom,
        zoomControl: true,
        styles: this.style,
        mapTypeId: this.type,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControlOptions: true,
        center: { lat: this.latitude, lng: this.longitude },
      });
    },
    heatmapPoints(points) {
      // eslint-disable-next-line no-undef
      return points.map(p => new google.maps.LatLng(p.lat, p.lng));
    },
    getGradient(color) {
      return [
        this.hexToRgba(color, 0),
        this.hexToRgba(color, 1),
        this.hexToRgba(color, 1),
      ];
    },
    hexToRgba(hex, opacity) {
      const color = hex.replace('#', '');
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);
      return `rgba(${r},${g},${b},${opacity / 1})`;
    },
  },
  computed: {
    mapWidth() {
      return typeof this.width === 'string' ? this.width : `${this.width}px`;
    },
    mapHeight() {
      return typeof this.height === 'string' ? this.height : `${this.height}px`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .msg-not-sector {
    text-align: center;
    margin-top: 0;
    color: rgba(0, 0, 0, 0.3);
    font-size: 12px;
    font-weight: 700;
    padding-top: 120px;
  }
</style>
